import { render } from "./IconCopied.vue?vue&type=template&id=2e0b9508"
const script = {}
script.render = render

export default script